import { DataRoomAccessPermission } from './data-room.enums';

/**
 * Why the file is being fetched.
 *
 * The two are the same byte stream: a view differs only in the header, and a file a browser cannot
 * show is saved instead of opened. What separates them is the button the person pressed, and
 * Views and Downloads are counted apart, so the intent has to arrive from the client: nothing
 * about the response could tell them apart afterwards.
 */
export enum SpaceFileIntent {
  DOWNLOAD = 'download',
  VIEW = 'view',
}

/**
 * Downloading is the one thing the two permissions differ on; opening a file is part of having
 * access at all. Shared so the menu item the client greys out is the request the server refuses.
 */
export const canDownloadSpaceFile = (permission: DataRoomAccessPermission): boolean =>
  permission === DataRoomAccessPermission.VIEWER_DOWNLOAD;
